/*
 * @Author: wenruihuan-home 409431215@qq.com
 * @Date: 2022-04-20 20:23:32
 * @LastEditors: wenruihuan-home 409431215@qq.com
 * @LastEditTime: 2022-07-17 20:03:52
 * @FilePath: \broadcasting\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import ElementUI from 'element-ui';
import App from './App.vue'
import store from './store'
import router from './router'
import vueRouter from 'vue-router'
import 'element-ui/lib/theme-chalk/index.css';
import '../src/assets/css/common.css'
import constants from '../src/common/js/constant'
import elTableInfiniteScroll from 'el-table-infinite-scroll';
// import locale from 'element-ui/lib/locale/lang/en'
//
// Vue.use(ElementUI, { locale })
Vue.use(elTableInfiniteScroll);
import VCalendar from 'v-calendar'; // 引入日历插件
Vue.use(VCalendar, {
  locale:'en',
  componentPrefix: 'vc',
});
Vue.config.productionTip = false
Vue.prototype.$constants = constants;
import md5 from 'js-md5';
Vue.prototype.$md5 = md5;
import "../src/common/js/flexible.js"
import commonButton from '../src/components/button'
import baiduMap from 'vue-baidu-map'
import commonSwitch from '../src/components/switch'
//导入图片预览viewer组件以及css
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import serverUrl from "@/common/js/constant";
Vue.use(Viewer);
Viewer.setDefaults({
  Options: { "inline": true, "button": true, "navbar": true, "title": true, "toolbar": true, "tooltip": true, "movable": true, "zoomable": true, "rotatable": true, "scalable": true, "transition": true, "fullscreen": true, "keyboard": true, "url": "data-source" }
});

Vue.use(ElementUI);
Vue.use(baiduMap, {
  ak: 'rHPkgrQYAOyIBSTlklD7ZHTg'
})
Vue.use(commonButton);
Vue.use(commonSwitch);
Vue.use(vueRouter);

//使用钩子函数对路由进行权限跳转
router.beforeEach((to, from, next) => {
  const role = sessionStorage.getItem('userId');
  var flg = true;
  if (!role||role==null){
    console.log("一键登录获取url")
    // 解析URL参数并更新sessionStorage
    const params = getURLParameters(window.location.href);
    if(params&&params!=null){
      console.log("到这》》》》》params:",params)
      const userId = params['userId'];
      if(userId||userId==null||userId==undefined){
        console.log("当前带参不合法")
      }else{
        const volumeState = params['volumeState'];
        const userRight ='管理员';
        const token = params['token'];
        const languageCookie = params['languageCookie'];
        const singlePoint = params['singlePoint'];
        const version = "标准版";
        flg = false;
        // 解码中文数据
        sessionStorage.setItem('userInfo',"超级管理员");
        sessionStorage.setItem("userId", userId);
        sessionStorage.setItem('userRights', userRight);
        sessionStorage.setItem("singlePoint",singlePoint);
        sessionStorage.setItem('volumeState',volumeState);
        sessionStorage.setItem('token',token);
        sessionStorage.setItem("language",languageCookie);
        sessionStorage.setItem("version",version);
        sessionStorage.setItem("singlePoint",singlePoint);
      }
    }
  }
  var cookies = window.document.cookie.split(";");
  console.log("到这》》》》》》》》》role",role)
  console.log("到这》》》》》》》》》flg",flg)
  if (cookies.length > 0) {
    for (var i = 0; i < cookies.length; i++) {
      if (cookies[i].indexOf("userId") != -1) {
        var userId = cookies[i].split("=")[1];
        console.log(userId);
        sessionStorage.setItem("userId", userId);
        sessionStorage.setItem('userInfo',"超级管理员");
        flg = false;
      }
      if (cookies[i].indexOf("volumeState") != -1) {
        var volumeState = cookies[i].split("=")[1];
        sessionStorage.setItem("volumeState", volumeState)
        flg = false;
      }
      if (cookies[i].indexOf("userRights") != -1) {
        var userRights = cookies[i].split("=")[1];
        sessionStorage.setItem("userRights", userRights)
        flg = false;
      }
      if (cookies[i].indexOf("token") != -1) {
        var token = cookies[i].split("=")[1];
        sessionStorage.setItem("token", token)
        flg = false;
      }
      if (cookies[i].indexOf("language") != -1) {
        var language = cookies[i].split("=")[1];
        sessionStorage.setItem("language", language)
        flg = false;
      }
      if (cookies[i].indexOf("singlePoint") != -1) {
        var singlePoint = cookies[i].split("=")[1];
        sessionStorage.setItem("singlePoint", singlePoint)
        flg = false;
      }
      if (cookies[i].indexOf("version") != -1) {
        var version = cookies[i].split("=")[1];
        sessionStorage.setItem("version", version)
        flg = false;
      }
    }
  }
  if (!role && to.path !== '/login'&&flg) {
    if(sessionStorage.getItem("singlePoint")==2){
      window.location.href=serverUrl.serverUrl+"/user/singleSignOn"
    }else{
      next('/login');
    }

  } else {
    next();
  }

});
function getURLParameters(url) {
  const params = {};
  const paramArray = url.slice(url.indexOf('?') + 1).split('&');

  for (let i = 0; i < paramArray.length; i++) {
    const param = paramArray[i].split('=');
    params[param[0]] = decodeURIComponent(param[1]);
  }

  return params;
}
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')

